
<div mat-dialog-content>
  <p>Please Enter Reason : </p>
  <mat-form-field style="width: 650px;">
    <mat-label>Reason</mat-label>
    <input matInput [(ngModel)]="data.msg">
  </mat-form-field>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">Cancel</button>
  <button mat-button [mat-dialog-close]="data.msg" cdkFocusInitial>Ok</button>
</div>
